.info {
	grid-row: 1 / 2;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 0.5rem;
	position: relative;
}
.info::before {
	content: ' ';
	position: absolute;
	display: block;
	top: 100%;
	left: 5%;
	width: 90%;
	height: 1px;
	background-color: var(--secondary);
}
.info > * {
	font-size: 0.8rem;
	color: var(--secondary);
	font-weight: 700;
}

.body {
	grid-row: 2 / 3;
	width: 100%;
	height: 100%;
	padding: 0.5rem;
	background-color: var(--depth1);
	border-radius: var(--roundedBig);
	text-align: left;
	transition-duration: var(--transitionSpeedFast);
	word-break: break-word;
}

.box {
	background-color: var(--depth1);
	transition-duration: var(--transitionSpeedFast);
	width: 34rem;
	height: fit-content;
	padding: 0;
}
